var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11538 6.70538C6.72581 6.31581 6.09419 6.31581 5.70462 6.70538C5.31534 7.09466 5.315 7.72569 5.70385 8.11538L8.8752 11.2937C9.2647 11.684 9.2647 12.316 8.8752 12.7063L5.70385 15.8846C5.315 16.2743 5.31534 16.9053 5.70462 17.2946C6.09419 17.6842 6.72581 17.6842 7.11538 17.2946L11.7029 12.7071C12.0934 12.3166 12.0934 11.6834 11.7029 11.2929L7.11538 6.70538Z",
    fill: "#5E639B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7052 6.70538C13.3157 6.31581 12.684 6.31581 12.2945 6.70538C11.9052 7.09466 11.9048 7.72569 12.2937 8.11538L15.465 11.2937C15.8545 11.684 15.8545 12.316 15.465 12.7063L12.2937 15.8846C11.9048 16.2743 11.9052 16.9053 12.2945 17.2946C12.684 17.6842 13.3157 17.6842 13.7052 17.2946L18.2927 12.7071C18.6833 12.3166 18.6833 11.6834 18.2927 11.2929L13.7052 6.70538Z",
    fill: "#5E639B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/DoubleArrowRight.e55190a35ed5500170cb9284a48113e9.svg";
export { ForwardRef as ReactComponent };